<template>
    <div class="otherTypes">
        <v-slide-group class="otherTypes__list" show-arrows v-if="isTabsInitialized">
            <v-slide-item v-for="(packageType) in packageType">
                <div class="otherTypes__item">
                    <img class="otherTypes__img" :src="packageType.img" :alt="packageType.name">
                    <h3 class="otherTypes__title">{{ packageType.name }}</h3>
                    <a class="otherTypes__link" :href="packageType.url"></a>
                </div>
            </v-slide-item>
        </v-slide-group>
    </div>
</template>

<script>
export default {
    name: "otherTypes",
    props: {
        branches: Array | Object | String,
    },
    data() {
        return {
            tab: null,
            isTabsInitialized: false,
            /*packageType: [

              {
                img: '/upload/iblock/17a/ihqoxr1bkckwx2fd16901527ax9c4lsh.png',
                name: 'Рыба, морепродукты',
                url: ''
              },
              {
                img: '/upload/iblock/17a/ihqoxr1bkckwx2fd16901527ax9c4lsh.png',
                name: 'Рыба, морепродукты',
                url: ''
              },
              {
                img: '/upload/iblock/90a/g9080m5ze1h17w3t39mtk6wvw9lozhlt/Kotlety-Krylya-Sborka.png',
                name: 'Мясо, птица',
                url: ''
              },
              {
                img: '/upload/iblock/a51/oq23bbkz402u7nwyzqpyq1je3x16d296.jpg',
                name: 'Молочная продукция',
                url: ''
              },
              {
                img: '/upload/iblock/ec1/1h51yx9dyfgbh22rm3uqz77desb7wd1f.jpg',
                name: 'Замороженная продукция',
                url: ''
              },
              {
                img: '/upload/iblock/e1e/7hsythdrpn070tqw3bmsfg61t29ko7kt.png',
                name: 'Кондитерские, хлебобулочные изделия',
                url: ''
              },
            ]*/
            packageType: this.branches,
        }
    },
    methods: {},
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.isTabsInitialized = true;
            }, 100);
        });


    },

}
</script>

<style scoped lang="scss">

.otherTypes {

  &__list {
    max-width: 1840px;
    padding-bottom: 90px;
  }

  &__item {
    width: calc(100% / 5);
    white-space: normal;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 32px;
    border: 1px solid #E8E8E8;
    padding: 24px;
    transition: all 0.3s ease;


    &:hover {

      & .otherTypes__title {
        color: #FA4237;
      }
    }

    &:last-of-type {
      margin-right: 0;
    }

    @media (max-width: 1024px) {
      width: calc(100% / 4);
    }

    @media (max-width: 900px) {
      width: calc(100% / 3);
    }

    @media (max-width: 768px) {
      width: calc(100% / 2);
    }

    @media (max-width: 355px) {
      max-width: 275px;
      max-height: 245px;
    }
  }

  &__link {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  &__img {
    width: 100%;
    max-width: 200px;
    height: 100%;
    max-height: 150px;
    object-fit: cover;
  }

  &__title {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 400;
    font-size: 24px;
    line-height: 28px;
    letter-spacing: 0px;
    color: #212424;
    margin: 0;
    white-space: normal !important;
    word-break: break-word !important;
    transition: all 0.3s ease;
  }

}

</style>

<style lang="scss">

.otherTypes {

  &__list {
    position: relative;

    & .v-slide-group__wrapper {
      height: 100% !important;
      max-height: 305px;
    }

    & .v-slide-group__content {
      padding: 19px 0;
    }

    .v-slide-group__prev,
    .v-slide-group__next {
      position: absolute;
      bottom: 10px;
      left: 52%;
      //transform: translateX(-50%);
      border: 1px solid #E6E6E6;
      border-radius: 8px;
      width: 56px;
      height: 56px;

      &:hover {
        border-color: #4F4D55;
      }
    }

    .v-icon.v-icon {
      font-size: 32px;
      color: #52525B;
    }

    .v-slide-group__prev, {
      left: calc(50% - 45px);

      @media (max-width: 1024px) {
        left: calc(50% - 60px);
      }
    }
  }


  .v-slide-group__content {
    gap: 8px;
  }

  .v-item-group {
    margin-top: 20px;


    .theme--light.v-card {
      background-color: transparent;
    }

  }

  .v-item-group.v-tabs-items {
    box-shadow: none !important;
  }

  .v-slide-group__wrapper {
    height: 75px;
  }


  .v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__prev, .v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__next {
    display: none;
  }

  .mdi-arrow-right-bold-box-outline::before {
    content: '';
    background: url("/upload/chevron-right.svg") no-repeat;
    background-size: contain;
    width: 40px;
    height: 40px;
  }

  .mdi-arrow-left-bold-box-outline::before {
    content: '';
    background: url("/upload/chevron-right.svg") no-repeat;
    background-size: contain;
    width: 40px;
    height: 40px;
    rotate: 180deg;
  }

  .v-slide-group__next, .v-slide-group__prev {
    min-width: 33px;
  }

}


</style>